import * as React from "react";

import { cn } from "@/lib/utils";

export interface FileChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  filename: string;
  range?: string;
}

const FileChip = React.forwardRef<HTMLSpanElement, FileChipProps>(({ className, filename, range, ...props }, ref) => (
  <span
    ref={ref}
    className={cn("inline-flex max-w-full items-center rounded border border-transparent bg-chip-muted px-1.5 py-0.5 font-mono text-xs text-chip-muted-foreground", className)}
    {...props}
  >
    <span className="truncate">{filename}</span>
    {range ? <span className="text-muted-foreground">:{range}</span> : null}
  </span>
));
FileChip.displayName = "FileChip";

export { FileChip };
